import { Modal, ModalContent } from '@chakra-ui/react';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { CustomNumberIcon, ErrorIcon } from '@sketchnote/icons';
import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Task } from 'src/features/tasks/types/tasks';

import { useAgileStore } from '../../store';

export const StoryCell = ({ task }: { task: any }): JSX.Element => {
  const testNum = (num): boolean => {
    const numeric = /^[0-9]+$/;
    return numeric.test(num);
  };

  const [fieldData, setFieldData] = useState('');
  const { onUpdateItemField, setItem } = useAgileStore();

  useEffect(() => {
    if (task?.storyPoint) {
      setFieldData(task.storyPoint);
    }
  }, [task.storyPoint]);
  const labelRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="flex pt-8 rounded-sm items-center">
      <div className="flex">
        <input
          type="number"
          className={cn(
            'text-sm text-gray-999 font-regular placeholder-gray-500 h-36 w-full pl-30',
            {
              'bg-white rounded-sm border border-gray-200': isFocused,
            }
          )}
          onChange={(e) => {
            setFieldData(e.target.value);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              if (testNum(fieldData)) {
                task._id &&
                  onUpdateItemField({
                    item: {
                      storyPoint: fieldData,
                      id: task._id,
                    },
                    keys: ['storyPoint'],
                  });
                setItem({ ...task, storyPoint: fieldData }, task.id);
                setIsFocused(false);
              } else if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(e.key)) {
                setFieldData('');
              }
            }
          }}
          onFocus={(e) => {
            setIsFocused(true);
          }}
          onBlur={(e) => {
            if (testNum(fieldData)) {
              task._id &&
                onUpdateItemField({
                  item: {
                    storyPoint: fieldData,
                    id: task._id,
                  },
                  keys: ['storyPoint'],
                });
              setItem({ ...task, storyPoint: fieldData }, task.id);

              setIsFocused(false);
            } else {
              setFieldData('');
              setIsFocused(false);
            }
          }}
          value={fieldData}
        />
      </div>
    </div>
  );
};
